var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSocialMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "nonzero",
    d: "M14.3333333,3 L1.66666667,3 C0.748,3 0,3.748 0,4.66666667 L0,12 C0,12.9186667 0.748,13.6666667 1.66666667,13.6666667 L14.3333333,13.6666667 C15.252,13.6666667 16,12.9186667 16,12 L16,4.66666667 C16,3.748 15.252,3 14.3333333,3 Z M5.88,8.92266667 L1.88,12.256 C1.818,12.308 1.742,12.3333333 1.66666667,12.3333333 C1.57066667,12.3333333 1.476,12.2926667 1.41,12.2133333 C1.292,12.072 1.31133333,11.8613333 1.45266667,11.7433333 L5.45266667,8.41 C5.594,8.29266667 5.80466667,8.312 5.92266667,8.45266667 C6.04066667,8.59466667 6.02133333,8.80533333 5.88,8.92266667 Z M8,9.01133333 C7.63333333,9.01133333 7.266,8.902 6.946,8.68266667 L1.47866667,4.942 C1.32666667,4.838 1.288,4.63066667 1.39133333,4.47866667 C1.49466667,4.32666667 1.702,4.28733333 1.85466667,4.392 L7.322,8.13266667 C7.73333333,8.414 8.26533333,8.414 8.67733333,8.13266667 L14.1446667,4.392 C14.2973333,4.28866667 14.5046667,4.32666667 14.608,4.47866667 C14.712,4.63066667 14.6733333,4.838 14.5213333,4.942 L9.054,8.68266667 C8.734,8.902 8.36666667,9.01133333 8,9.01133333 Z M14.5893333,12.2133333 C14.5233333,12.2926667 14.4286667,12.3333333 14.3333333,12.3333333 C14.258,12.3333333 14.1826667,12.308 14.12,12.256 L10.12,8.92266667 C9.97866667,8.80466667 9.95933333,8.59466667 10.0773333,8.45266667 C10.1953333,8.312 10.4053333,8.29266667 10.5473333,8.41 L14.5473333,11.7433333 C14.688,11.8613333 14.7073333,12.072 14.5893333,12.2133333 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#FFF",
    fillOpacity: 0.01
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocialMail);
export default __webpack_public_path__ + "static/media/ic-social-mail.983ec7b7bcc2283808adc11f4cabed92.svg";
export { ForwardRef as ReactComponent };